import React from 'react'

const HorizontalChartToolTip = ({ active, payload, label }) => {   
    if (active && payload && payload.length) {
        return (
            <div className="custom-horizontal-chart-tooltip">
                 <p className="label">{`${label}`}</p>
                 <p className="value">{`Value: ${payload[0].value}`}</p>
            </div>
          );
    }  
    return null;
  };

  export default HorizontalChartToolTip;